export function GetAlertRasonKey(item: string): string {
  return `ALERT-REASON.${item
    .toString()
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')}`;
}

export class Constants {
  public static get STATE_ACTIVE(): number {
    return 0x001;
  }
  public static get STATE_INACTIVE(): number {
    return 0x002;
  }
  public static get STATE_PENDING(): number {
    return 0x003;
  }
  public static get STATE_DELETED(): number {
    return 0x010;
  }

  public static get STATE_FINALIZADA(): number {
    return 0x019;
  }
  public static get STATE_CLOSE(): number {
    return 0x020;
  }
  public static get STATE_ALARM(): number {
    return 0x040;
  }
  public static get STATE_BATTERY(): number {
    return 0x080;
  }
  public static get STATE_OFFLINE(): number {
    return 0x100;
  }

  public static get STATE_LOGIN(): number {
    return 0x05;
  }

  public static get ROLE_SYSTEM_SUPER_ADMINISTRATOR(): string {
    return 'SA';
  }
  public static get ROLE_SYSTEM_ADMINISTRATOR(): string {
    return 'AD';
  }
  public static get ROLE_MONITOR(): string {
    return 'MO';
  }
  public static get ROLE_OPERATOR(): string {
    return 'OP';
  }
  public static get ROLE_VIEWER(): string {
    return 'VI';
  }

  public static getRolesExcept(roles: string | Array<string>): Array<string> {
    return [];
  }

  public static get LAYOUT_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
      this.ROLE_MONITOR,
      this.ROLE_VIEWER,
    ];
  }

  public static get LAYOUT_ACCESS_DENIED(): string {
    return 'access-denied';
  }
  public static get LAYOUT_NOT_FOUNDD(): string {
    return 'not-found';
  }
  public static get LAYOUT_ERROR(): string {
    return 'error';
  }

  public static get LAYOUT_LAYOUT(): string {
    return '';
  }
  public static get LAYOUT_LOGIN(): string {
    return 'login';
  }
  public static get LAYOUT_RECOVER(): string {
    return 'recover';
  }
  public static get LAYOUT_NEWMAIL(): string {
    return 'validateMail';
  }
  public static get LAYOUT_RECOVER_EXPIRED(): string {
    return 'recover-expired';
  }

  public static get LAYOUT_HOME(): string {
    return 'home';
  }

  public static get LAYOUT_CALL_OUT(): string {
    return 'call-out';
  }

  public static get LAYOUT_CALL_IN(): string {
    return 'call-in';
  }

  public static get LAYOUT_USERS(): string {
    return 'users';
  }
  public static get LAYOUT_USERS_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
    ];
  }

  public static get LAYOUT_PERSONAS(): string {
    return 'personas';
  }
  public static get LAYOUT_PERSONAS_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
      this.ROLE_MONITOR,
    ];
  }

  public static get LAYOUT_PERSONAS_INFO(): string {
    return 'personas-info';
  }
  public static get LAYOUT_PERSONAS_INFO_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
      this.ROLE_MONITOR,
    ];
  }

  public static get LAYOUT_PHONES(): string {
    return 'phones';
  }
  public static get LAYOUT_PHONES_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
    ];
  }

  public static get LAYOUT_DIRECCIONES(): string {
    return 'direcciones';
  }
  public static get LAYOUT_DIRECCIONES_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
    ];
  }

  public static get LAYOUT_DEVICES(): string {
    return 'devices';
  }
  public static get LAYOUT_DEVICES_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
    ];
  }

  public static get LAYOUT_EVENTS(): string {
    return 'events';
  }
  public static get LAYOUT_EVENTS_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
    ];
  }

  public static get LAYOUT_STATS(): string {
    return 'stats';
  }
  public static get LAYOUT_STATS_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
      this.ROLE_MONITOR,
    ];
  }

  public static get LAYOUT_MAPA_ADMIN(): string {
    return 'mapa-admin';
  }
  public static get LAYOUT_MAPA_ADMIN_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_MONITOR,
    ];
  }

  public static get LAYOUT_MAPA_VIEWER(): string {
    return 'mapa-viewer';
  }
  public static get LAYOUT_MAPA_VIEWER_SECURITY(): string[] {
    return [this.ROLE_VIEWER];
  }

  public static get LAYOUT_MAPA_OP(): string {
    return 'mapa';
  }
  public static get LAYOUT_MAPA_OP_SECURITY(): string[] {
    return [this.ROLE_OPERATOR];
  }

  public static get LAYOUT_DEVICE_EVENTS(): string {
    return 'device-event';
  }
  public static get LAYOUT_DEVICE_EVENTS_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_VIEWER,
      this.ROLE_OPERATOR,
    ];
  }

  public static get LAYOUT_PROPERTIES(): string {
    return 'properties';
  }
  public static get LAYOUT_PROPERTIES_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR];
  }
  public static get LAYOUT_CONFIG(): string {
    return 'config';
  }
  public static get LAYOUT_CONFIG_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR];
  }

  public static get LAYOUT_COMMANDS(): string {
    return 'commands';
  }
  public static get LAYOUT_COMMANDS_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR];
  }

  public static get LAYOUT_MONITOR(): string {
    return 'monitor';
  }
  public static get LAYOUT_MONITOR_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
      this.ROLE_MONITOR,
      this.ROLE_VIEWER,
    ];
  }

  public static get LAYOUT_REPORTS(): string {
    return 'reports';
  }
  public static get LAYOUT_REPORTS_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_MONITOR,
    ];
  }

  public static get LAYOUT_TECNICA(): string {
    return 'tecnica';
  }
  public static get LAYOUT_TECNICA_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR, this.ROLE_MONITOR];
  }

  public static get LAYOUT_CALL_OUT_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR, this.ROLE_MONITOR];
  }

  public static get LAYOUT_CALL_IN_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR, this.ROLE_MONITOR];
  }

  public static get LAYOUT_NEWSFLASH_ADM(): string {
    return 'newsflash-adm';
  }
  public static get LAYOUT_NEWSFLASH_ADM_SECURITY(): string[] {
    return [this.ROLE_SYSTEM_SUPER_ADMINISTRATOR];
  }

  public static get LAYOUT_NEWSFLASH(): string {
    return 'newsflash';
  }
  public static get LAYOUT_NEWSFLASH_SECURITY(): string[] {
    return [
      this.ROLE_SYSTEM_SUPER_ADMINISTRATOR,
      this.ROLE_SYSTEM_ADMINISTRATOR,
      this.ROLE_OPERATOR,
      this.ROLE_MONITOR,
      this.ROLE_VIEWER,
    ];
  }
}
